import * as React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { ApolloError } from 'apollo-client';

import ToastActions from 'actions/ToastActions';
// @ts-ignore
import { touch } from 'actions/touchActions';
import { TOUCH_KEY as NAV_TOUCH_KEY } from 'components/NavigationList/NavigationList';
import ErrorReporter from 'app/components/ErrorReporter';
import GroupByCodeFetcher from 'groups/containers/GroupByCodeFetcher';
import PendingGroupPage from 'groups/components/PendingGroupPage';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

import CANCEL_REQUEST from 'groupMembershipRequests/containers/mutations/CancelGroupMembershipRequest.gql';
import { cancelGroupMembershipRequestVariables } from 'groupMembershipRequests/containers/mutations/__generated__/cancelGroupMembershipRequest';

type Props = {
  params: { groupCode: string };
};

export default class PendingGroupContainer extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  render() {
    const { groupCode } = this.props.params;

    return (
      <GroupByCodeFetcher groupCode={groupCode}>
        {({ group, loading, error }) => {
          if (loading) {
            return <CenteredLoadingIndicator />;
          }

          if (error || !group) {
            return <ErrorReporter error="PendingGroupContainer - failed to fetch group" />;
          }

          const { organization, groupAvatar } = group;
          const { router } = this.context;

          if (!groupAvatar) {
            // This should never actually happen, the typing returned by graphql is wrong.
            return <ErrorReporter error="PendingGroupContainer - group has no avatar" />;
          }

          return (
            <Mutation
              mutation={CANCEL_REQUEST}
              onCompleted={() => {
                ToastActions.showSuccessToast('Request to join canceled')
                touch(NAV_TOUCH_KEY);
                router.push('/classes');
              }}
              onError={(error: ApolloError) => ToastActions.showErrorToast(error.message)}>
              {(
                cancelRequest: (input: { variables: cancelGroupMembershipRequestVariables }) => void
              ) => (
                <PendingGroupPage
                  uuid={group.uuid}
                  groupName={group.className}
                  groupAvatarUrl={groupAvatar.svgUrl}
                  code={group.name}
                  orgName={organization && organization.name}
                  onCancelRequest={groupUuid => cancelRequest({ variables: { input: { groupUuid } } })}
                />
              )}
            </Mutation>
          );
        }}
      </GroupByCodeFetcher>
    );
  }
}
